import React, { useContext, useEffect, useState } from "react";
import * as _ from "lodash";

import "../EUMRVPortStays/EUMRVPortStays.scss";

import CustomTable from "../../../../../../common/customTable/CustomTable";
import {
	EmissionsAfterDerogationColumns,
	EUMRV_PORTSTAYS_HEADERS,
	ETS_COLUMN_KEYS,
	MRV_COLUMN_KEYS
} from "../../../../../../constants/CustomTableHeaders";
import { ClaimsContext } from "../../../../../../services/ClaimsService";
import { FeatureType } from "../../../../../../constants/FeatureToggles";

const EmissionsAfterDerogation = ({ data, loading }) => {
	const [columnData, setColumndata] = useState(
		EmissionsAfterDerogationColumns
	);
	const staticColumns = EmissionsAfterDerogationColumns;
	const { userHasFeature } = useContext(ClaimsContext) || {};
	

	// Refine the data by adding a "DieselGasOilCons" entry if not present
	useEffect(() => {
		if (
			data &&
			data[0]?.portStayConsumptions.some(
				(fuel) => fuel.fuelName === "MDO" || fuel.fuelName === "MGO"
			)
		) {
			data?.forEach((entry) => {
				if (
					entry?.portStayConsumptions.every(
						(fuel) => fuel.fuelName !== "DieselGasOilCons"
					)
				) {
					entry.portStayConsumptions.unshift({
						fuelName: "DieselGasOilCons",
						consumption: entry.dieselGasOilCons,
					});
				}
			});
		}
	}, [data]);

	// method to filter dynamic columns based on non-zero values
	const getFilteredColumns = (data, columnType, columns) => {
		const nonZeroNames = new Set();

		// Collect non-zero fuel names based on the type (consumption, MNC, transport work)
		data?.forEach((item) => {
			item[columnType]?.forEach((entry) => {
				if (
					columnType === "portStayConsumptions" &&
					entry.consumption !== 0 &&
					entry.consumption !== null &&
					entry.consumption !== undefined
				) {
					nonZeroNames.add(entry?.fuelName);
				}
				if (
					columnType === "portStayMncs" &&
					entry.mnc !== 0 &&
					entry.mnc !== null &&
					entry.mnc !== undefined
				) {
					nonZeroNames.add(entry?.fuelName);
				}
			});
		});

		// Filter columns based on non-zero values
		return columns.filter((column) => {
			const name = column.accessorKey.split("_")[1];
			return nonZeroNames.has(name);
		});
	};

	// method to filter static columns based on non-zero values
	const getFilteredStaticColumns = (objArray, staticColumns) => {
		const nonZeroHeaders = new Set();
		objArray?.forEach((obj) => {
			Object?.entries(obj)?.forEach(([key, value]) => {
				if (value !== 0 && value !== null && value !== undefined) {
					nonZeroHeaders.add(key);
				}
			});
		});
		return staticColumns.filter((column) =>
         nonZeroHeaders.has(column.accessorKey)
		);
	};

	const GetPossibleKeys = (allData, dataType, keyName) => {
		return _.chain(allData).flatMap(dataType).map(keyName).uniq().value();
	};

	const getDynamicColumns = (data) => {
		const dynamicConsColumns = [];
		const dynamicMncColumns = [];

		if (Array.isArray(data[0]?.portStayConsumptions)) {
			const possibleKeys = GetPossibleKeys(
				data,
				"portStayConsumptions",
				"fuelName"
			);
			possibleKeys?.forEach((item) => {
				dynamicConsColumns.push({
					id: `portStayConsumptions_${item}`,
					accessorKey: `portStayConsumptions_${item}`,
					header: `${item === "DieselGasOilCons"
						? "Diesel/Gas Oil Cons. (MT)"
						: `${item} Cons. (MT)`
						}`,
					Cell: ({ row }) =>
						row?.original?.portStayConsumptions.find(
							(fuel) => fuel?.fuelName === item
						)?.consumption || 0,
				});
			});
		}
		if (Array.isArray(data[0]?.portStayMncs)) {
			const possibleKeys = GetPossibleKeys(
				data,
				"portStayMncs",
				"fuelName"
			);
			possibleKeys?.forEach((item) => {
				dynamicMncColumns.push({
					id: `portStayMncs_${item}`,
					accessorKey: `portStayMncs_${item}`,
					header: `${item} MNC. (MT)`,
					Cell: ({ row }) =>
						row?.original?.portStayMncs.find(
							(fuel) => fuel?.fuelName === item
						)?.mnc || 0,
				});
			});
		}
		return {
			dynamicConsColumns: getFilteredColumns(
				data,
				"portStayConsumptions",
				dynamicConsColumns
			),
			dynamicMncColumns: getFilteredColumns(
				data,
				"portStayMncs",
				dynamicMncColumns
			),
		};
	};

	useEffect(() => {
		const filterColumnsByIndex = (columns) => {
			const idsToExclude =MRV_COLUMN_KEYS ;
			return columns.filter((col) => !idsToExclude.includes(col.accessorKey));
		};

		if (loading) {
			setColumndata(filterColumnsByIndex(staticColumns));
			return;
		}

		if (data && data.length > 0) {
			const { dynamicConsColumns, dynamicMncColumns } = getDynamicColumns(data);

			const dynamicEUMRVPortStaysColumnsData =
				dynamicConsColumns || dynamicMncColumns
					? [
							...staticColumns.slice(0, 1),
							...getFilteredStaticColumns(data, staticColumns.slice(1, 8)),
							...dynamicConsColumns,
							...dynamicMncColumns,
							...getFilteredStaticColumns(data, staticColumns.slice(8)),
					  ]
					: getFilteredStaticColumns(data, staticColumns);
			setColumndata(filterColumnsByIndex(dynamicEUMRVPortStaysColumnsData));
		} else {
			setColumndata(filterColumnsByIndex(staticColumns));
		}
	}, [data, loading]);


	return (
		<div className="mt-4 emission-reported eu_mrv_ps">
			<CustomTable
				columnsData={columnData}
				renderTableData={data || []}
				customProps={{
					header: EUMRV_PORTSTAYS_HEADERS.EMISSION_DEROGATION,
					enableSort: false,
					isLoading: loading,
					tableName: "emissions-report",
					maxHeight: "30vh",
					columnOrder: columnData.map((column) => column.accessorKey),
				}}
			/>
		</div>
	);
};

export default EmissionsAfterDerogation;
